<template>
  <div
    class="overflow-x-auto margin-bottom-16 background-surface padding-24 border-radius-8 border--solid border--complementary-50"
  >
    <div class="font-size-14 color-complementary-400 margin-bottom-24">
      {{ $lang.LineScoreMultipleChartTitle }}
    </div>
    <div class="min-width-1200 width--max-content">
      <b-row
        class="direction--ltr height-300 flex-wrap-reverse width-percent-100 disable-select"
      >
        <b-col>
          <span
            class="font-size-12 text-complementary-300 flex position-absolute bottom-30 writing-mode--vertical-rl"
          >
            {{ $lang.LineScoreMultipleChartLeftTitle }}
          </span>
          <div
            class="font-size-12 text-complementary-300 flex align-items-end justify-content-between flex-column-reverse height-percent-100"
          >
            <span class="span-percent-line">0%</span>
            <span class="span-percent-line">10%</span>
            <span class="span-percent-line">20%</span>
            <span class="span-percent-line">30%</span>
          </div>
        </b-col>
        <b-col class="padding-4 flex-end flex-column gap-4">
          <b-img-lazy
            v-for="({ fullName, image, performance }, index) in generateItems(
              8,
              14
            )"
            :key="index"
            class="z-index-1 width-32 height-32 border-radius-50"
            v-b-tooltip.hover
            :title="`${fullName} (${performance})`"
            :src="image"
            :onerror="`this.src='${defaultImage}';this.classList.add('padding-3', 'background-surface')`"
          />
          <div
            class="width-percent-100 height-68 background-error position-absolute bottom-0"
          />
        </b-col>
        <b-col class="padding-4 flex-end flex-column gap-4">
          <b-img-lazy
            v-for="({ fullName, image, performance }, index) in generateItems(
              14,
              21
            )"
            :key="index"
            class="z-index-1 width-32 height-32 border-radius-50"
            v-b-tooltip.hover
            :title="`${fullName} (${performance})`"
            :src="image"
            :onerror="`this.src='${defaultImage}';this.classList.add('padding-3', 'background-surface')`"
          />
          <div
            class="width-percent-100 height-159 background-error-400 position-absolute bottom-0"
          />
        </b-col>
        <b-col class="padding-4 flex-end flex-column gap-4">
          <b-img-lazy
            v-for="({ fullName, image, performance }, index) in generateItems(
              21,
              27
            )"
            :key="index"
            class="z-index-1 width-32 height-32 border-radius-50"
            v-b-tooltip.hover
            :title="`${fullName} (${performance})`"
            :src="image"
            :onerror="`this.src='${defaultImage}';this.classList.add('padding-3', 'background-surface')`"
          />
          <div
            class="width-percent-100 height-227 background-error-300 position-absolute bottom-0"
          />
        </b-col>
        <b-col class="padding-4 flex-end flex-column gap-4">
          <b-img-lazy
            v-for="({ fullName, image, performance }, index) in generateItems(
              27,
              34
            )"
            :key="index"
            class="z-index-1 width-32 height-32 border-radius-50"
            v-b-tooltip.hover
            :title="`${fullName} (${performance})`"
            :src="image"
            :onerror="`this.src='${defaultImage}';this.classList.add('padding-3', 'background-surface')`"
          />
          <div
            class="width-percent-100 height-242 background-warning position-absolute bottom-0"
          />
        </b-col>
        <b-col class="padding-4 flex-end flex-column gap-4">
          <b-img-lazy
            v-for="({ fullName, image, performance }, index) in generateItems(
              34,
              40
            )"
            :key="index"
            class="z-index-1 width-32 height-32 border-radius-50"
            v-b-tooltip.hover
            :title="`${fullName} (${performance})`"
            :src="image"
            :onerror="`this.src='${defaultImage}';this.classList.add('padding-3', 'background-surface')`"
          />
          <div
            class="width-percent-100 height-98 background-warning-400 position-absolute bottom-0"
          />
        </b-col>
        <b-col class="padding-4 flex-end flex-column gap-4">
          <b-img-lazy
            v-for="({ fullName, image, performance }, index) in generateItems(
              40,
              47
            )"
            :key="index"
            class="z-index-1 width-32 height-32 border-radius-50"
            v-b-tooltip.hover
            :title="`${fullName} (${performance})`"
            :src="image"
            :onerror="`this.src='${defaultImage}';this.classList.add('padding-3', 'background-surface')`"
          />
          <div
            class="width-percent-100 height-69 background-warning-300 position-absolute bottom-0"
          />
        </b-col>
        <b-col class="padding-4 flex-end flex-column gap-4">
          <b-img-lazy
            v-for="({ fullName, image, performance }, index) in generateItems(
              47,
              53
            )"
            :key="index"
            class="z-index-1 width-32 height-32 border-radius-50"
            v-b-tooltip.hover
            :title="`${fullName} (${performance})`"
            :src="image"
            :onerror="`this.src='${defaultImage}';this.classList.add('padding-3', 'background-surface')`"
          />
          <div
            class="width-percent-100 height-66 background-success position-absolute bottom-0"
          />
        </b-col>
        <b-col class="padding-4 flex-end flex-column gap-4">
          <b-img-lazy
            v-for="({ fullName, image, performance }, index) in generateItems(
              53,
              60
            )"
            :key="index"
            class="z-index-1 width-32 height-32 border-radius-50"
            v-b-tooltip.hover
            :title="`${fullName} (${performance})`"
            :src="image"
            :onerror="`this.src='${defaultImage}';this.classList.add('padding-3', 'background-surface')`"
          />
          <div
            class="width-percent-100 height-29 background-success-400 position-absolute bottom-0"
          />
        </b-col>
        <b-col class="padding-4 flex-end flex-column gap-4">
          <b-img-lazy
            v-for="({ fullName, image, performance }, index) in generateItems(
              60,
              66
            )"
            :key="index"
            class="z-index-1 width-32 height-32 border-radius-50"
            v-b-tooltip.hover
            :title="`${fullName} (${performance})`"
            :src="image"
            :onerror="`this.src='${defaultImage}';this.classList.add('padding-3', 'background-surface')`"
          />
          <div
            class="width-percent-100 height-11 background-success-300 position-absolute bottom-0"
          />
        </b-col>
        <b-col class="padding-4 flex-end flex-column gap-4">
          <b-img-lazy
            v-for="({ fullName, image, performance }, index) in generateItems(
              66,
              73
            )"
            :key="index"
            class="z-index-1 width-32 height-32 border-radius-50"
            v-b-tooltip.hover
            :title="`${fullName} (${performance})`"
            :src="image"
            :onerror="`this.src='${defaultImage}';this.classList.add('padding-3', 'background-surface')`"
          />
          <div
            class="width-percent-100 height-2 background-success-800 position-absolute bottom-0"
          />
        </b-col>
        <b-col class="padding-4 flex-end flex-column gap-4">
          <b-img-lazy
            v-for="({ fullName, image, performance }, index) in generateItems(
              73,
              79
            )"
            :key="index"
            class="z-index-1 width-32 height-32 border-radius-50"
            v-b-tooltip.hover
            :title="`${fullName} (${performance})`"
            :src="image"
            :onerror="`this.src='${defaultImage}';this.classList.add('padding-3', 'background-surface')`"
          />
          <div
            class="width-percent-100 height-2 background-success-900 position-absolute bottom-0"
          />
        </b-col>
      </b-row>
      <b-row class="direction--ltr width-percent-100">
        <b-col> </b-col>
        <b-col
          class="padding-4 width-percent-100 font-size-11 flex-center color-complementary-300"
        >
          [8%, 14%]
        </b-col>
        <b-col
          class="padding-4 width-percent-100 font-size-11 flex-center color-complementary-300"
        >
          [14%, 21%]
        </b-col>
        <b-col
          class="padding-4 width-percent-100 font-size-11 flex-center color-complementary-300"
        >
          [21%, 27%]
        </b-col>
        <b-col
          class="padding-4 width-percent-100 font-size-11 flex-center color-complementary-300"
        >
          [27%, 34%]
        </b-col>
        <b-col
          class="padding-4 width-percent-100 font-size-11 flex-center color-complementary-300"
        >
          [34%, 40%]
        </b-col>
        <b-col
          class="padding-4 width-percent-100 font-size-11 flex-center color-complementary-300"
        >
          [40%, 47%]
        </b-col>
        <b-col
          class="padding-4 width-percent-100 font-size-11 flex-center color-complementary-300"
        >
          [47%, 53%]
        </b-col>
        <b-col
          class="padding-4 width-percent-100 font-size-11 flex-center color-complementary-300"
        >
          [53%, 60%]
        </b-col>
        <b-col
          class="padding-4 width-percent-100 font-size-11 flex-center color-complementary-300"
        >
          [60%, 66%]
        </b-col>
        <b-col
          class="padding-4 width-percent-100 font-size-11 flex-center color-complementary-300"
        >
          [66%, 73%]
        </b-col>
        <b-col
          class="padding-4 width-percent-100 font-size-11 flex-center color-complementary-300"
        >
          [73%, 79%]
        </b-col>
        <b-col
          cols="12"
          class="font-size-12 flex-center color-complementary-300"
        >
          {{ $lang.LineScoreMultipleChartBottomTitle }}
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { generateConfig } from "@/shared/utils";
import { toRefs } from "vue";

export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const { items } = toRefs(props);
    const generateItems = (start, end) => {
      return items.value
        .filter(
          ({ performance }) =>
            performance && performance >= start && performance < end
        )
        .map(({ performance, image, fullName }) => {
          return {
            performance,
            image,
            fullName,
          };
        });
    };

    const defaultImage = generateConfig([
      "images",
      "shared",
      "redesign",
      "empty",
      "noUser",
    ]);

    return { generateItems, defaultImage };
  },
};
</script>
